<template>
  <l-default :class="b()">
    <c-container>
      <c-breadcrumb :class="b('breadcrumb')" />
      <c-page-header :config="pageHeaderConfig" />

      <div :class="b('container')">
        <div :class="b('list')">
          <template v-if="categories.length">
            <c-teaser-tile
              v-for="category in categories"
              :id="category.id"
              :key="category.id"
              :url="category.relativeUrl"
              :heading="category.name"
              :description="category.description"
              :image="category.imageMain"
              show-read-more
            />
          </template>
        </div>
        <p
          v-if="!categories.length"
          :class="b('no-categories-found')"
        >
          {{ $t('l-categories-overview.no-categories-found') }}
        </p>
      </div>
    </c-container>
  </l-default>
</template>

<script lang="ts">
  import { PropType, defineComponent } from 'vue';
  import cBreadcrumb from '@/components/c-breadcrumb.vue';
  import cContainer from '@/components/c-container.vue';
  import cPageHeader, { PageHeaderConfig } from '@/components/c-page-header.vue';
  import cTeaserTile from '@/components/c-teaser-tile.vue';
  import lDefault from '@/layouts/l-default.vue';
  import { CategoriesOverviewCategory as Category } from '@/types/category';

  // type Setup = {};

  // type Data = {};

  /**
   * Renders an article list page.
   */
  export default defineComponent({
    name: 'l-categories-overview',

    components: {
      cBreadcrumb,
      cPageHeader,
      cContainer,
      lDefault,
      cTeaserTile,
    },

    props: {
      /**
       * The Page Header Config
       */
      pageHeaderConfig: {
        type: Object as PropType<PageHeaderConfig>,
        required: true,
      },

      /**
       * The product categories.
       */
      categories: {
        type: Array as PropType<Category[]>,
        default: () => [],
      },
    },
    // emits: {},

    // setup(): Setup {
    //   return {};
    // },
    // data(): Data {
    //   return {};
    // },

    // computed: {},
    // watch: {},

    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // activated() {},
    // deactivated() {},
    // beforeUnmount() {},
    // unmounted() {},

    // methods: {},
    // render() {},
  });
</script>

<style lang="scss">
  @use 'sass:map';
  @use '@/setup/scss/mixins';
  @use '@/setup/scss/variables';

  .l-categories-overview {
    padding: 3rem 0;

    &__breadcrumb {
      margin-bottom: 3rem;
    }

    &__container {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      @include mixins.media(md) {
        flex-direction: row;
      }
    }

    &__list {
      $list-gap-size: 1.5rem;

      display: grid;
      grid-template-columns: 1fr;
      gap: $list-gap-size;
      align-items: start;

      @include mixins.media(md) {
        grid-template-columns: repeat(2, calc(50% - $list-gap-size));
      }

      @include mixins.media(lg) {
        grid-template-columns: repeat(3, calc(33% - ($list-gap-size / 2)));
      }
    }

    &__no-categories-found {
      font-style: italic;
      padding: 1rem;
    }
  }
</style>
